import React from 'react'
import { Slider } from '@kaleyra/emmy'
import { useTranslation } from 'react-i18next'
import MainTemplate from '../C2CModal/containers/MainTemplate'
import Styles from './index.module.scss'
import { C2CModalInterface } from '../../store/models/C2CModal.interface'

export type MapStateToPropsType = {
    C2CModal: C2CModalInterface,
}

export type MapDispatchToPropsType = {
    closeC2CModal: () => void,
}

const C2CModal: React.FC<MapStateToPropsType & MapDispatchToPropsType> = (props) => {
    const { modalSource, showModal } = props.C2CModal
    const { t } = useTranslation()

    const source: any = {
        'NEW_CONVERSATION': t('click2call'),
        'LOGS': t('startCall'),
        'C2C': t('click2call'),
    }

    const renderBody = () => {
        if (showModal) {
            return (
                <Slider
                    visibility={showModal}
                    containerId='root-modal'
                    title={source[modalSource] || source.NEW_CONVERSATION}
                    containerClassName={Styles.sliderHeight}
                    onClose={() => props.closeC2CModal()}
                >
                    <MainTemplate />

                </Slider>
            )
        }
        return null
    }

    return (
        renderBody()
    )
}

export default C2CModal